// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import FinanceDimensionValue from "./finance-dimension-value.js"

const modelClassData = {
  "attributes": {
    "finance_dimension_value_id": {
      "column": {
        "default": null,
        "name": "finance_dimension_value_id",
        "null": false,
        "type": "uuid"
      },
      "name": "finance_dimension_value_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "locked_finance_dimension_value_id": {
      "column": {
        "default": null,
        "name": "locked_finance_dimension_value_id",
        "null": false,
        "type": "uuid"
      },
      "name": "locked_finance_dimension_value_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "LockedFinanceDimensionValue",
  "collectionKey": "locked_finance_dimension_values",
  "collectionName": "locked_finance_dimension_values",
  "i18nKey": "locked_finance_dimension_value",
  "camelizedLower": "lockedFinanceDimensionValue",
  "name": "LockedFinanceDimensionValue",
  "nameDasherized": "locked-finance-dimension-value",
  "pluralName": "locked_finance_dimension_values",
  "ransackable_associations": [
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_dimension_value",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "locked_finance_dimension_value_id",
      "name": "locked_finance_dimension_value",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "finance_dimension_value_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "locked_finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "locked_finance_dimension_value_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "old_finance_dimension_value_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_locked_finance_dimension_value_id",
      "column": {
        "default": null,
        "name": "old_locked_finance_dimension_value_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "finance_dimension_value_id",
      "name": "finance_dimension_value",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    },
    {
      "className": "FinanceDimensionValue",
      "collectionName": "finance_dimension_values",
      "foreignKey": "locked_finance_dimension_value_id",
      "name": "locked_finance_dimension_value",
      "macro": "belongs_to",
      "resource_name": "FinanceDimensionValue",
      "through": null
    }
  ],
  "paramKey": "locked_finance_dimension_value",
  "primaryKey": "id"
}

/** Frontend model for LockedFinanceDimensionValue. */
export default class LockedFinanceDimensionValue extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  financeDimensionValueId() {
    return this.readAttributeUnderscore("finance_dimension_value_id")
  }

  /** @returns {boolean} */
  hasFinanceDimensionValueId() {
    const value = this.financeDimensionValueId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  lockedFinanceDimensionValueId() {
    return this.readAttributeUnderscore("locked_finance_dimension_value_id")
  }

  /** @returns {boolean} */
  hasLockedFinanceDimensionValueId() {
    const value = this.lockedFinanceDimensionValueId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceLock(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_lock",
        collectionName: "locked_finance_dimension_values",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static workplaceUnlock(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "workplace_unlock",
        collectionName: "locked_finance_dimension_values",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./finance-dimension-value.js").default | null} */
  financeDimensionValue() {
    return this._readBelongsToReflection({modelClass: FinanceDimensionValue, reflectionName: "finance_dimension_value"})
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  loadFinanceDimensionValue() {
    if (!("financeDimensionValueId" in this)) throw new Error("Foreign key method wasn't defined: financeDimensionValueId")

    const id = this.financeDimensionValueId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_dimension_value",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  ensureFinanceDimensionValueLoaded() {
    return this.ensureAssociationLoaded("finance_dimension_value")
  }

  /** @returns {import("./finance-dimension-value.js").default | null} */
  lockedFinanceDimensionValue() {
    return this._readBelongsToReflection({modelClass: FinanceDimensionValue, reflectionName: "locked_finance_dimension_value"})
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  loadLockedFinanceDimensionValue() {
    if (!("lockedFinanceDimensionValueId" in this)) throw new Error("Foreign key method wasn't defined: lockedFinanceDimensionValueId")

    const id = this.lockedFinanceDimensionValueId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "locked_finance_dimension_value",
        model: this,
        modelClass: FinanceDimensionValue
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-dimension-value.js").default | null>} */
  ensureLockedFinanceDimensionValueLoaded() {
    return this.ensureAssociationLoaded("locked_finance_dimension_value")
  }
}
